var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24,
    r: 17,
    stroke: "#6092DB",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7195 27C24.5915 26.9817 24.4268 26.9817 24.2805 27C21.061 26.8901 18.5 24.2519 18.5 21.0092C18.5 17.6931 21.1707 15 24.5 15C27.811 15 30.5 17.6931 30.5 21.0092C30.4817 24.2519 27.939 26.8901 24.7195 27Z",
    stroke: "#6092DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 37.4082C31.859 39.6428 28.3576 41 24.5 41C20.6424 41 17.1409 39.6428 14.5 37.4082C14.6484 36.1196 15.5386 34.8583 17.1261 33.8713C21.1914 31.3762 27.8383 31.3762 31.8739 33.8713C33.4614 34.8583 34.3516 36.1196 34.5 37.4082Z",
    stroke: "#6092DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.63a84433.svg";
export { ForwardRef as ReactComponent };